import { render, staticRenderFns } from "./detailsdy.vue?vue&type=template&id=2ae40a52&scoped=true&"
import script from "./detailsdy.vue?vue&type=script&lang=js&"
export * from "./detailsdy.vue?vue&type=script&lang=js&"
import style0 from "./detailsdy.vue?vue&type=style&index=0&id=2ae40a52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae40a52",
  null
  
)

component.options.__file = "detailsdy.vue"
export default component.exports